// extracted by mini-css-extract-plugin
export default {"text":"campaignInfo_text__q67eK","heading":"campaignInfo_heading__BtxU5"};